import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lowerText'
})
export class LowerTextPipe implements PipeTransform {

    public transform(input: any, length = 19): string {
        if(typeof input == "string"){
            if (input.length <= length) {
                return input;
            } else {
                return input.substring(0, length - 1) + "...";
            }
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/lower-text.pipe.ts